import { CircularProgress } from '@material-ui/core';
import Button from 'components/CustomButtons/Button';
import CustomTable from 'components/CustomTable/CustomTable';
import { translate } from 'components/Translation';
import { BodyM } from 'components/Typography/Typography';
import moment from 'moment';
import React from 'react';
import { hideLoadingIndicator, showLoadingIndicator } from 'redux/modules/api/loadingIndicator/actions';
import { setToast } from 'redux/modules/toast/actions';
import { dispatch } from 'redux/store';
import { finalize } from 'rxjs/operators';
import { BillsService } from 'services/bills/bills';
import { BillingRequest, BillingStatus } from 'utils/api/models/bills/bills';

interface IDownloadZipTableProps {
	data: BillingRequest[];
}

const DownloadZipTable = ({ data }: IDownloadZipTableProps) => {
	const handleDownload = (original: BillingRequest) => {
		dispatch(showLoadingIndicator());
		if (original.periodMonth && original.periodYear)
			BillsService.downloadBillingRequest({
				period: moment(original.periodYear + '/' + original.periodMonth, 'YYYY M').format('YYYY-MM'),
			})
				.pipe(finalize(() => dispatch(hideLoadingIndicator())))
				.subscribe(({ response }) => {
					if (response) {
						try {
							const href = window.URL.createObjectURL(response);
							const a = document.createElement('a');
							a.style.display = 'none';
							a.href = href;
							a.download = `Bills ${moment().format('LLL')}`;
							document.body.appendChild(a);
							a.click();
							window.URL.revokeObjectURL(href);
						} catch (error) {
							dispatch(
								setToast({
									error: true,
									actionType: translate('error'),
									label: translate('error.generic-title'),
								})
							);
						}
					}
				});
	};

	const columns: any[] = [
		{
			Header: translate('month'),
			sortable: false,
			Cell: ({ original }: { original: BillingRequest }) => (
				<BodyM>{moment(original.periodMonth + '-' + original.periodYear, 'MM-YYYY').format('MM-YYYY')}</BodyM>
			),
		},
		{
			sortable: false,
			Cell: ({ original }: { original: BillingRequest }) => {
				if (original.status === BillingStatus.READY) {
					return (
						<Button color="primary-light" onClick={() => handleDownload(original)}>
							{translate('download')}
						</Button>
					);
				} else {
					return <CircularProgress />;
				}
			},
		},
	];
	return (
		<CustomTable
			withHeader={false}
			showPaginationTop={false}
			total={data.length}
			tableProps={{
				data: data,
				columns: columns,
				defaultPageSize: data.length,
				stroke: true,
			}}
		/>
	);
};

export default DownloadZipTable;
